import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "./Loader";
import UserContext from "../context/UserContext";

function Filter() {
  const { setProducts } = useContext(UserContext);
  const navigate = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState();
  const category = [
    "Novels",
    "Hard cover story",
    "Board books",
    "Lift and flip",
    "Early readers",
  ];

  useEffect(() => {
    setLoading(true);

    fetch(`${process.env.REACT_APP_API_URL}/product/get?category=${params.cat}`)
      .then((res) => res.json())
      .then((data) => {
        setProducts(data);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, [params]);

  return (
    <>
      <Loader loading={loading} />
      <div className="filter-con">
        <div className="filter">
          <ul className="flex items-center gap-5">
            <span className="border rounded-full w-[200px] p-1 text-gray-500">
              <p>Filter by category</p>
              <br />
              <select
                className="focus:outline-none w-full bg-transparent"
                onChange={(e) => navigate(`/product/${e.target.value}`)}
              >
                <option value={"all"}>All</option>
                {category.map((value) => {
                  return (
                    <option key={value} value={value}>
                      {value}
                    </option>
                  );
                })}
              </select>
            </span>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Filter;
